/* eslint-disable react/no-unused-prop-types,react/no-danger,react/no-unescaped-entities,jsx-a11y/href-no-hash,react/self-closing-comp,react/prefer-stateless-function,react/forbid-prop-types */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from "react-helmet";
import postscribe from "postscribe";
import {filterHTML, isInternalLink} from "../../helpers/filters";
import {getVideoId} from "../../helpers/video";
import InlineModalVideo from "../../components/InlineModalVideo";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {trackEventByUrl} from "../../helpers/events";
import {twillBase} from "../../config/API";
import "./WhatsNew.scss";

class WhatsNew extends Component {

    static propTypes = {
        post_type: PropTypes.string,
        permalink: PropTypes.string,
        id: PropTypes.number,
        archive: PropTypes.bool,
        published: PropTypes.bool,
        title: PropTypes.string,
        featured_image: PropTypes.object,
        position: PropTypes.number,
        background_type: PropTypes.string,
        background_color: PropTypes.string,
        backgroundImage: PropTypes.string,
        text_color: PropTypes.string,
        headline: PropTypes.string,
        body: PropTypes.string,
        ctaStyle: PropTypes.string,
        ctaColor: PropTypes.string,
        ctaOutlineStyle: PropTypes.bool,
        cta_outline_color: PropTypes.string,
        ctaText: PropTypes.string,
        cta: PropTypes.string,
        secondCta: PropTypes.bool,
        ctaLabelTwo: PropTypes.string,
        ctaTwo: PropTypes.string,
        bottom_banner: PropTypes.string,
        visible_client_uk: PropTypes.bool,
        visible_client_na: PropTypes.bool,
        visible_client_latin: PropTypes.bool,
        visible_client_mena: PropTypes.bool,
        visible_client_asia: PropTypes.bool,
        visible_dealer_uk: PropTypes.bool,
        visible_dealer_na: PropTypes.bool,
        visible_dealer_latin: PropTypes.bool,
        visible_dealer_mena: PropTypes.bool,
        visible_dealer_asia: PropTypes.bool,
        ctaStyles: PropTypes.object,
        secondCtaStyles: PropTypes.object,
    };

    static defaultProps = {
        post_type: '',
        permalink: '',
        id: '',
        archive: false,
        published: false,
        title: '',
        featured_image: {
            url: '',
            alt: ''
        },
        position: 0,
        background_type: '',
        background_color: '',
        backgroundImage: {
            url: '',
            alt: ''
        },
        text_color: '',
        headline: '',
        body: '',
        ctaStyle: '',
        ctaColor: '',
        ctaOutlineStyle: false,
        cta_outline_color: '',
        ctaText: '',
        cta: '',
        secondCta: false,
        ctaLabelTwo: '',
        ctaTwo: '',
        bottom_banner: '',
        visible_client_uk: false,
        visible_client_na: false,
        visible_client_latin: false,
        visible_client_mena: false,
        visible_client_asia: false,
        visible_dealer_uk: false,
        visible_dealer_na: false,
        visible_dealer_latin: false,
        visible_dealer_mena: false,
        visible_dealer_asia: false,
        ctaStyles: {
            'outline_style': '',
            'class': ''
        },
        secondCtaStyles: {
            'outline_style': '',
            'class': ''
        }
    };

    // Not currently used, but here for consistency with other Twill conversions such as KnowledgeCenterQuery
    static getWhatsNewItems = async () => fetch(`${twillBase}/api/whats-new`).then(res => res.json())

    state = {
        stylesLoaded: false,
    }

    async componentDidMount() {
        await this.loadExternalStylesheet();
    }

    getTextColor = () => this.props.text_color === 'light' ? '#fff' : '#000';

    /**
     * Convert a String-based `style` tag to an Object for React
     * @param string
     * @returns {{}}
     */
    convertStyleStringToObject = string => {
        if (!string) return {};

        const cssJson = `{"${string
            .replace(/; /g, '", "')
            .replace(/: /g, '": "')
            .replace(";", "")}"}`;

        const obj = JSON.parse(cssJson);

        const keyValues = Object.keys(obj).map((key) => {
            const camelCased = key.replace(/-[a-z]/g, (g) => g[1].toUpperCase());
            return { [camelCased]: obj[key] };
        });
        return Object.assign({}, ...keyValues)
    }

    loadExternalStylesheet = async () => {
        const manifestPath = '/external-app-css-react';
        const url = `${twillBase}${manifestPath}`.replace(/\/$/, '');

        await fetch(url).then(res => res.text()).then(filePath => {
            if (!this.state.stylesLoaded) {
                postscribe(`#whatsNew-${this.props.id}`, `<link rel="stylesheet" href="${filePath}">`);
                this.setState({stylesLoaded: true});
            }
        }).catch(err => {
            console.log(err);
            return null;
        });
    };

    renderLink = (ctaText, ctaLink, ctaStyles) => {

        if (!this.props.cta) {
            return null;
        }

        const isInternal = isInternalLink(this.props.cta);
        const videoId = getVideoId(this.props.cta);

        const title = ctaText || 'View';
        if (videoId) return (
            <InlineModalVideo videoId={videoId}
                              videoUrl={this.props.cta}
                              title={title} />
        );

        return (
            <a className={`cta ${ctaStyles.class}`}
               style={this.convertStyleStringToObject(ctaStyles.outline_style)}
               href={this.props.cta}
               target="_blank"
               onClick={() => trackEventByUrl(this.props.cta, title)}
               rel={isInternal ? null : 'noopener noreferrer'}>
                {title}
            </a>
        );
    };

    render() {
        // Build the Background object to inject
        let entity = {};
        if (this.props.background_type === 'color') entity = {
            fieldColorBackground: this.props.background_color,
        };
        if (this.props.background_type === 'image') entity = {
            fieldObjectImg: this.props.backgroundImage
        };

        // Generate Styles Object
        const styles = fieldObjectSectionStyleCss({
            entity: {
                fieldObjectBackground: {
                    entity
                }
            }
        });

        return (

            <div className="page-whatsNew" id={`whatsNew-${this.props.id}`}>

                <Helmet>
                    <title>{this.props.title || 'What\'s New'} | MarketAxess</title>
                </Helmet>

                {this.state.stylesLoaded ? (
                    <div className={`main${styles.classNames}`} style={styles.css} >

                        {styles.childBackground.isActive && (
                            <div style={styles.childBackground.css}/>
                        )}

                        <section className="whatsNew__main">
                            <div className="container whatsNew__mainContent">

                                <div className="whatsNew__text whatsNew__contentModule">
                                    {this.props.headline && (
                                        <h1 style={{color: this.getTextColor()}} dangerouslySetInnerHTML={{__html: filterHTML(this.props.headline)}}/>
                                    )}

                                    {this.props.body && (
                                        <div style={{color: this.getTextColor()}} dangerouslySetInnerHTML={{__html: filterHTML(this.props.body)}}/>
                                    )}

                                    {this.renderLink(this.props.ctaText, this.props.cta, this.props.ctaStyles)}


                                    {this.props.secondCta ? (
                                        <div style={{marginTop: '16px'}}>
                                            {this.renderLink(this.props.ctaLabelTwo, this.props.ctaTwo, this.props.secondCtaStyles)}
                                        </div>
                                    ) : null}

                                </div>

                                {this.props.featured_image && this.props.featured_image.url && (
                                    <div className="whatsNew__image whatsNew__contentModule">
                                        <img src={this.props.featured_image.url} alt={this.props.featured_image.alt} />
                                    </div>
                                )}

                            </div>

                            {this.props.bottom_banner && (
                                <div className="whatsNew__bottomBanner">
                                    <div className="container">
                                        <div className="whatsNew__bottomBannerContent" dangerouslySetInnerHTML={{__html: filterHTML(this.props.bottom_banner)}}/>
                                    </div>
                                </div>
                            )}

                        </section>

                    </div>

                ) : null}
            </div>

        );
    }
}

export default WhatsNew;



// WEBPACK FOOTER //
// ./frontend/pages/WhatsNew/WhatsNew.jsx